<template>
  <Info2Column title="ID">
    <p v-if="isEditMode">{{ userInfo.loginId }}</p>
    <input
      v-else
      v-model="userInfo.loginId"
      type="text"
      :placeholder="t('alert_enter_id')"
      @input="blockInputInvalidId"
    />
  </Info2Column>

  <Info2Column :title="t('label_name')">
    <input
      v-model="userInfo.nickname"
      autocomplete="off"
      type="text"
      :placeholder="t('alert_enter_name')"
      @keydown="blockInputInvalidPassword"
    />
  </Info2Column>

  <Info2Column :title="t('label_password')">
    <input
      v-model="userInfo.password"
      autocomplete="new-password"
      :type="showPassword[0] ? 'text' : 'password'"
      :placeholder="t('input_login_pw')"
      @keydown="blockInputInvalidPassword"
      class="text-input"
    />
    <EyeIcon class="eye-icon icon-dim" :showPassword="showPassword[0]" @click="togglePasswordVisibility(0)" />
  </Info2Column>

  <Info2Column :title="t('alert_confirm_password')">
    <input
      v-model="userInfo.passwordConfirm"
      autocomplete="new-password"
      :type="showPassword[1] ? 'text' : 'password'"
      :placeholder="t('alert_reenter_password')"
      @keydown="blockInputInvalidPassword"
    />
    <EyeIcon class="eye-icon icon-dim" :showPassword="showPassword[1]" @click="togglePasswordVisibility(1)" />
  </Info2Column>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import EyeIcon from '@/components/icons/IconEye.vue';
import Info2Column from '@/components/shared/composite/Info2Column.vue';
import { IUserInfo } from '@/types/components';
import { blockInputInvalidId, blockInputInvalidPassword } from '@/utils/validatorInput';

const userInfo = defineModel<IUserInfo>({
  required: true,
  default: () => ({}) as IUserInfo,
});

withDefaults(
  defineProps<{
    isEditMode: boolean;
  }>(),
  {
    isEditMode: false,
  }
);

const { t } = useI18n();

const showPassword = ref<boolean[]>([false, false]);

const togglePasswordVisibility = (inx: number) => {
  showPassword.value[inx] = !showPassword.value[inx];
};
</script>

<style scoped lang="scss">
.content-wrapper {
  display: block !important;
  :deep(p) {
    padding-bottom: 0.5rem;
  }
}
.eye-icon {
  position: absolute;
  right: 0.5rem;
  bottom: 0;
  transform: translateY(-50%);
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
}
</style>
